import React, { Component } from 'react';
import './Header.css';
import logo from './Images/logo.png';
import Logout from '../Auth/Logout';
import { connect } from 'react-redux';
import { logoutUser, validateToken } from '../../Store/Actions/LoginActions';
class Header extends Component {

	componentDidMount(){
		// This will check for refreshes and fetch recent data from token validate call
		if (!this.props.isAuthorized && localStorage.getItem("id_token")){
			this.props.tokenValidate(localStorage.getItem("id_token")); 
		}
	}
	render() {
		let firstName = localStorage.getItem("userFirstName");
		let lastName = localStorage.getItem("userLastName");
		let accessCode = localStorage.getItem("accessCode");
		if (this.props.isAuthorized) {
			return (
				<div className="topBar">
					<div className="container">
						<a href="/schedule"><img src={logo} className="ars-logo" alt="ars logo" /></a>
						<Logout onLogoutClick={this.props.onLogoutClick} />

						<span className="header-text">Access Code: <span className="access-code"> {accessCode}</span></span>
						<span className="header-text">{firstName} {lastName}</span>
					</div>
				</div>
			);
		}
		return (
			<div className="topBar">
				<div className="container">
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		isAuthorized: state.auth.isAuthenticated
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onLogoutClick: () => dispatch(logoutUser()),
		tokenValidate: (token) => dispatch(validateToken(token))
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js